export class CreateWorkflowDTO {
  idSinistre: string;
  idClient: string;
  idContact: string;

  constructor(idSinistre?, idClient?, idContact?) {
    this.idSinistre = idSinistre || '';
    this.idClient = idClient || '';
    this.idContact = idContact || '';
  }
}